import {
    LOCAL
} from '../constants/funcUrl'

const localMutation = {
    [LOCAL.ENROLLSTUDENT](state, data) {
        let obj = _.find(state.enrollstudent, { 'JobId': data.JobId })
        if (obj) {
            // 删除已经存在的
            _.pull(state.enrollstudent, obj);
        }
        state.enrollstudent.push(data);
    },
    [LOCAL.ENROLL](state, data) {
        state.enroll = data;
    }

}

export default localMutation;



// WEBPACK FOOTER //
// ./src/store/jzjy/mutations/localMutation.js